const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const timeSince = (date: any) => {
    if (!date) {
        date = new Date();
    }

    if (typeof date == "string") {
        date = new Date(date);
    }

    var seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);

    var interval = Math.floor(seconds / 31536000);

    if (interval > 1) {
        //   return interval + " years";
        return date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
    }
    interval = Math.floor(seconds / 2592000);
    if (interval > 1) {
        //   return interval + " months";
        return date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
    }
    interval = Math.floor(seconds / 86400);
    if (interval > 0) {
        //   return interval + " days";
        if (15 > interval) {
            return interval + " days ago"
        }
        return "on " + date.getDate() + " " + months[date.getMonth()];
    }
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
        return interval + " hrs ago";
    }
    interval = Math.floor(seconds / 60);
    if (interval > 1) {
        return interval + " min ago";
    }
    if (seconds < 0) {
        seconds = 0;
    }
    return Math.floor(seconds) + " sec ago";
}

const timeDate = (date: any) => {
    if (!date) {
        date = new Date();
    }

    if (typeof date == "string") {
        date = new Date(date);
    }
    
    let d = date;
    let h = d.getHours();
    h = h < 10 ? "0" + h : h;
    let m = d.getMinutes();
    m = m < 10 ? "0" + m : m;
    let day = d.getDate();
    day = day < 10 ? "0" + day : day;
    
    return `${h}:${m} ${months[d.getMonth()]} ${day} ${d.getFullYear()}`
}

const dateTime = (date: any) => {
    
    if (!date) {
        date = new Date();
    }

    if (typeof date == "string") {
        date = new Date(date);
    }

    let d = date;
    let h = d.getHours();
    h = h < 10 ? "0" + h : h;
    let m = d.getMinutes();
    m = m < 10 ? "0" + m : m;
    let s = d.getSeconds();
    s = s < 10 ? "0" + s : s;
    let day = d.getDate();
    day = day < 10 ? "0" + day : day;
    let month = d.getMonth() + 1;
    month = month < 10 ? "0" + month : month;

    return `${day}/${month}/${d.getFullYear()} at ${h}:${m}:${s}`
}

const getTimeAgo = (provided: any) => {
    const msPMin = 60 * 1000;
    const msPHr = msPMin * 60;
    const msPDay = msPHr * 24;
    const msPWeek = msPDay * 7;
    const msPMon = msPDay * 30;
    const msPYr = msPMon * 365;

    const elapsed = Date.now() - Date.parse(provided);

    if (elapsed < msPMin) return Math.round(elapsed / 1000) + "Sec";
    if (elapsed < msPHr) return Math.round(elapsed / msPMin) + "Min";
    if (elapsed < msPDay) return Math.round(elapsed / msPHr) + "H";
    if (elapsed < msPWeek) return Math.round(elapsed / msPDay) + "D";
    if (elapsed < msPMon) return Math.round(elapsed / msPWeek) + "W";
    if (elapsed < msPYr) return Math.round(elapsed / msPMon) + "M";
    return Math.round(elapsed / msPYr) + "Y";
}

const dateISOtoYMD = (date: any) => {
    if (!date) {
        date = new Date();
    }

    if (typeof date == "string") {
        date = new Date(date);
    }

    let d = date;
    let h = d.getHours();
    h = h < 10 ? "0" + h : h;
    let m = d.getMinutes();
    m = m < 10 ? "0" + m : m;
    let s = d.getSeconds();
    s = s < 10 ? "0" + s : s;
    let day = d.getDate();
    day = day < 10 ? "0" + day : day;
    let month = d.getMonth() + 1;
    month = month < 10 ? "0" + month : month;

    return `${d.getFullYear()}-${month}-${day}`
}

const dateService = {
    timeSince,
    timeDate,
    dateTime,
    getTimeAgo,
    dateISOtoYMD
}

export default dateService;